__turbopack_context__.v({
  "GridContainer": "GridList-module-scss-module__clyQMa__GridContainer",
  "GridContainer___column": "GridList-module-scss-module__clyQMa__GridContainer___column",
  "GridContainer___fullWidth": "GridList-module-scss-module__clyQMa__GridContainer___fullWidth",
  "GridContainer___row": "GridList-module-scss-module__clyQMa__GridContainer___row",
});
